import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfc40dec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  style: {"font-size":"smaller"}
}

import { PropType, ref, h, computed } from 'vue'
import Empty from '../../componects/Empty.vue'

const __default__ = {
  name: 'OverdueAmountTypeListView'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '260px'
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => {
      return []
    }
  }
},
  setup(__props) {

const props = __props

const columns = computed(() => [
  { title: tableTitle('业务员'), dataIndex: 'employeeName' },
  { title: tableTitle('合计'), dataIndex: 'totalPartAmount' },
  { title: tableTitle('1-30天'), dataIndex: 'apartAmount' },
  { title: tableTitle('31-60天'), dataIndex: 'bpartAmount' },
  { title: tableTitle('61-90天'), dataIndex: 'cpartAmount' },
  { title: tableTitle('91-180天'), dataIndex: 'dpartAmount' },
  { title: tableTitle('181-360天'), dataIndex: 'epartAmount' },
  { title: tableTitle('360天以上'), dataIndex: 'fpartAmount' }
])

const tableTitle = (n1, n2) => {
  if (!n2) return h('div', { style: { fontSize: "smaller" } }, n1)
  return h('div', { style: { fontSize: "smaller" } }, [
    h('p', null, n1),
    h('span', null, n2)
  ])
}

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    columns: columns.value,
    scroll: { y: '164px' },
    style: _normalizeStyle({ width: __props.width, height: __props.height }),
    dataSource: props.data,
    size: "small",
    pagination: false
  }, {
    emptyText: _withCtx(() => [
      _createVNode(Empty)
    ]),
    bodyCell: _withCtx(({ column, record }) => [
      (column.dataIndex === 'employeeName')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(record.employeeName || '合计'), 1)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record[column.dataIndex]), 1))
    ]),
    _: 1
  }, 8, ["columns", "style", "dataSource"]))
}
}

})